import Api from '@/services/Api'

export default {
    getActivityConfigurationCompanies(params) {
        return Api().get("/activity-configuration-companies/"+params);
    },
    updateActivityConfigurationCompany(params) {
        return Api().put("/activity-configuration-companies", params);
    },
    addActivityConfigurationCompany(params) {
        return Api().post("/activity-configuration-companies", params);
    },
    getActivityConfigurationCompany(params) {
        return Api().get("/activity-configuration-companies/" + params);
    },
    deleteActivityConfigurationCompany(params) {
        return Api().delete("/activity-configuration-companies/" + params);
    },
    getActivityConfigurationsCompanyByFather(params) {
        return Api().post("/activity-configuration-companies-by-father" ,params);
    },
    createFirstData(params) {
        return Api().get("activity-configuration-companies-create-data/" + params);
    },
    getActivityConfigurationCompanyAreEnable(params) {
        return Api().get("/activity-configuration-company-enable/"+params);
    },




}



// WEBPACK FOOTER //
// ./src/services/ActivityConfigurationCompanyService.js